var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyDocDark = function SvgEmptyDocDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty-doc-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3D3D",
    d: "M4.36 0h50.624v63.422H4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M67.64 21.234V72H17.017V8.578h37.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3D3D",
    d: "M33.89 21.234h16.876v4.219H33.89zM25.453 29.672h33.75v4.218h-33.75zM25.453 38.11h33.75v4.218h-33.75zM25.453 46.547h33.75v4.218h-33.75zM25.453 54.984h33.75v4.219h-33.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B4C4D",
    d: "M54.984 8.578v12.656h12.657z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty-doc-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
};
export default SvgEmptyDocDark;